import useCustomers from 'src/hooks/use-customers';
import {getCurrentCustomerId} from 'src/helpers/customer';
import {useDevices} from 'src/autobahn/features/devices/queries';

export interface EntityOption {
  id: number;
  label: string;
  search: string;
  customerId?: number;
}

export const normalize = (text: string) => text.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();

// Reads the MobX customer store: the calling component must be an observer to see it finish loading.
export const useEntityOptions = () => {
  const {customers: customerStore} = useCustomers({all: true});
  const {data: devices = []} = useDevices();
  const centralId = getCurrentCustomerId();

  const customers: EntityOption[] = (customerStore.list as {id: number; name: string}[])
      .filter((customer) => customer.id !== centralId)
      .map((customer) => ({id: customer.id, label: customer.name, search: normalize(customer.name || '')}));

  const deviceOptions: EntityOption[] = devices.map((device) => {
    const plate = (device.attributes?.plate as string | undefined) || '';
    const label = plate && plate !== device.name ? `${device.name} (${plate})` : device.name;
    return {id: device.id, label, search: normalize(`${device.name || ''} ${plate}`), customerId: device.customerId};
  });

  return {customers, devices: deviceOptions};
};
